<script>
import map from 'lodash/map';
import Multiselect from 'vue-multiselect';
import ParamModel from '@models/Param';

export default {
  components: {
    Multiselect,
  },
  props: {
    // eslint-disable-next-line
    value: {
      required: true,
    },
    initialValue: {
      default: null,
      type: Object,
    },
    placeholder: {
      default: 'Select multiple organizers',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    state: {
      default: false,
      type: Boolean,
    },
    sort: {
      type: String,
      default: 'username',
    },
  },
  data() {
    return {
      admins: [],
      isLoading: false,
      selectedEntities: this.initialValue,
      focused: false,
      minChars: 2,
    };
  },
  watch: {
    selectedEntities(val) {
      const id = val ? val.id : null;
      this.$emit('input', id);
      this.$emit('change', id);
    },
    initialValue() {
      this.selectedEntities = this.initialValue;
    },
  },
  mounted() {
    ParamModel.params({
      select_many: ['admins'].join(','),
    }).orderBy('last_name')
      .first()
      .then((response) => {
        this.admins = map(response.admins, (item) => ({ name: item.name, id: item.id }));
      });
  },
};
</script>

<template>
  <div class="multiselect-container kks-multiselect-container" :class="{ 'is-invalid': state, focused: focused }">
    <Multiselect
      ref="multiselect"
      v-model="selectedEntities"
      label="name"
      track-by="id"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="admins"
      :multiple="false"
      :searchable="false"
      :loading="isLoading"
      :clear-on-select="true"
      :close-on-select="false"
      :preserve-search="true"
      :max-height="600"
      :disabled="disabled"
      @open="focused = true"
      @close="focused = false"
    >
      <div slot="noResult" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
      <div slot="noOptions" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
    </Multiselect>
  </div>
</template>
